import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { mixinAriaHeadingLevel } from '@mtna/core-angular';
import { RdsDataProduct } from '@rds/rds-metadata-ts';

/**
 * Banner with either id or name and expansion panel for description.
 *
 * @author Zach Edwards <zach.edwards@mtna.us
 */

const _DataProductBannerMixin = mixinAriaHeadingLevel(class {}, '2');

/* eslint-disable @angular-eslint/no-inputs-metadata-property */

@Component({
  selector: 'rds-c-data-product-banner',
  template: `
    <div class="data-product-banner" fxLayout="row" fxLayoutAlign="space-between start">
      <div class="data-product-banner-title" role="heading" [attr.aria-level]="ariaHeadingLevel">
        {{ dataProduct?.name || dataProduct?.id || _noDataProductSelectedPlaceholder | uppercase }}
      </div>
      <button class="data-product-banner-change-button" (click)="changeDataProduct.emit()" i18n>CHANGE DATA PRODUCT</button>
    </div>
  `,
  styleUrls: ['./data-product-banner.scss'],
  inputs: ['ariaHeadingLevel'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsDataProductBannerComponent extends _DataProductBannerMixin {
  @HostBinding('attr.role') landmarkRole = 'complementary';
  @HostBinding('attr.aria-label') ariaLabel = 'RDS Data Product Banner';

  @Input()
  set dataProduct(dataProduct: RdsDataProduct | null | undefined) {
    this._dataProduct = dataProduct;
  }
  get dataProduct() {
    return this._dataProduct;
  }
  private _dataProduct: RdsDataProduct | null | undefined;

  @Output() changeDataProduct = new EventEmitter<null>();

  _noDataProductSelectedPlaceholder = $localize`No data product selected`;
}
